import {
  Either,
  GetOrdersResult,
  left,
  OrdersFailure,
  OrdersRepository,
  OrderState,
  right,
} from "../../domain";
import { OrdersRemoteDataSourceError } from "../core";
import { OrdersRemoteDataSource } from "../data-sources";

export class OrdersRepositoryImpl implements OrdersRepository {
  constructor(private readonly remoteDataSource: OrdersRemoteDataSource) {}

  private handleError(error: OrdersRemoteDataSourceError): OrdersFailure {
    if (error === "NetworkError") return OrdersFailure.networkFailure();
    return OrdersFailure.serverFailure();
  }

  public async edit(
    id: string,
    state: OrderState,
    postalTrackingCode?: string
  ): Promise<Either<OrdersFailure, null>> {
    try {
      await this.remoteDataSource.edit(id, state, postalTrackingCode);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async list(
    page: number,
    state: OrderState | "ALL",
    startDate?: string,
    endDate?: string,
    search?: string
  ): Promise<Either<OrdersFailure, GetOrdersResult>> {
    try {
      const res = await this.remoteDataSource.list(
        page,
        state,
        startDate,
        endDate,
        search
      );
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async sendOrderInfoSms(
    id: string
  ): Promise<Either<OrdersFailure, null>> {
    try {
      await this.remoteDataSource.sendOrderInfoSms(id);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async toggleIsPackaged(
    id: string
  ): Promise<Either<OrdersFailure, null>> {
    try {
      await this.remoteDataSource.toggleIsPackaged(id);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
